import { PapiEditorText } from '@wix/da-papi-types';
import { SchemaVersion } from '@wix/da-editor-tiptap/pkg/server/types';

export const initPapiEditorText = (): PapiEditorText => {
  const doc = {
    version: SchemaVersion.V1,
    document: {
      type: 'doc',
      content: [{
        type: 'paragraph',
        attrs: {
          indentType: null,
          indentation: null,
          textAlign: 'left',
        },
      }],
    },
  };
  return {
    excerpt: '',
    html: {
      type: 'tiptap',
      markup: JSON.stringify(doc),
      features: '[]',
    },
  };
};
